import { Space } from "antd";
import styled from "styled-components";

export const StyledPopoverContainer = styled(Space).attrs({
  direction: "vertical",
})`
  display: flex;
  gap: 0px;
  .ant-space-item {
    width: 100%;
  }
`;

export const StyledBtnContainer = styled(Space)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 4px;
`;

export const StyledLabel = styled.label`
  color: rgba(0, 0, 0, 0.55);
`;
